import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "DAF2TreasuryModelerGlobal" })((_theme) => ({
  page: {
    margin: "20px",
  },

  DAF2ModelerGlobalExportBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "-30px",
  },
  SaveBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "10px",
  },
}));
